import { useContext } from 'react';
import MessageContext, { IMessageContextValues } from 'Contexts/MessageContext';

const useMessages = (): IMessageContextValues => {
  return useContext(MessageContext);
};

export default useMessages;
